import { ArrayInput, FormDataConsumer, SimpleFormIterator, ReferenceInput, SelectInput, NumberInput } from "react-admin";
import Grid from "@mui/material/Grid";

const CCLInputs = ({ scopedFormData, getSource }) => (
  <Grid
    container
    spacing={2}
    sx={{
      "& .MuiGrid-item:not(:first-of-type)": { pt: 0 },
      mt: 0,
    }}
  >
    <Grid item xs={12}>
      <ReferenceInput
        source={getSource("category_id")}
        reference="categories"
        perPage={20}
        sort={{ field: "display_order", order: "ASC" }}
        fullWidth
      >
        <SelectInput optionText="name" optionValue="id" fullWidth />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} md={6}>
      <NumberInput
        source={getSource("loan_tenor")}
        label="Loan tenor (hari)"
        fullWidth
        min={1}        
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <NumberInput
        source={getSource("loan_tenor_tolerance")}
        label="Loan tenor tolerance (hari)"
        fullWidth
        min={0}        
      />
    </Grid>
  </Grid>
);

export default function CustomerCategoryLimitForm() {
  return (
    <ArrayInput
      source="customer_category_limits"
      defaultValue={[
        {
          category_id: "",
          loan_tenor: "",
          loan_tenor_tolerance: "",
        },
      ]}
    >
      <SimpleFormIterator getItemLabel={(index) => `#${index + 1}`}>
        <FormDataConsumer>{CCLInputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
